const STATUS_LABELS: Record<string, string> = {
  pending_pickup: 'Pre-announced',
  in_transit: 'In Transit',
  out_for_delivery: 'Out for Delivery',
  delivered: 'Delivered',
  failed_delivery: 'Failed',
  returned: 'Returned',
  unconfirmed: 'Unconfirmed',
  no_info: 'No Info from PostNL',
};

export function formatTrackingStatusLabel(status: string): string {
  return STATUS_LABELS[status] || status
    .split('_')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function getStatusBadgeClasses(status: string): string {
  switch (status) {
    case 'delivered':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
    case 'in_transit':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
    case 'out_for_delivery':
      return 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400';
    case 'pending_pickup':
      return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400';
    case 'failed_delivery':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
    case 'returned':
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400';
    case 'unconfirmed':
      return 'bg-gray-100 text-gray-600 dark:bg-gray-700/50 dark:text-gray-400';
    case 'no_info':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
  }
}

export function getStatusExportLabel(status: string): string {
  return STATUS_LABELS[status] || status
    .split('_')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
